import { render, staticRenderFns } from "./InventoryImportModal.vue?vue&type=template&id=47cb0345"
import script from "./InventoryImportModal.vue?vue&type=script&lang=ts"
export * from "./InventoryImportModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports